import app from 'flarum/forum/app';
export const sourceDeclarationKeys = ['original', 'repost', 'reference'];
export function isSourceDeclarationKey(key) {
  return sourceDeclarationKeys.includes(key);
}
export const definitions = [{
  key: 'original',
  icon: 'fas fa-certificate',
  color: '#2f855a',
  category: 'source',
  attribute: 'creatorDeclarationOriginalEnabled'
}, {
  key: 'repost',
  icon: 'fas fa-link',
  color: '#64748b',
  category: 'source',
  attribute: 'creatorDeclarationRepostEnabled',
  detailsType: 'url'
}, {
  key: 'reference',
  icon: 'fas fa-quote-left',
  color: '#64748b',
  category: 'source',
  attribute: 'creatorDeclarationReferenceEnabled',
  detailsType: 'url'
}, {
  key: 'ai_generated',
  icon: 'fas fa-wand-magic-sparkles',
  color: '#6557d2',
  category: 'authenticity',
  attribute: 'creatorDeclarationAiGeneratedEnabled',
  detailsType: 'text'
}, {
  key: 'fictional',
  icon: 'fas fa-masks-theater',
  color: '#7c3aed',
  category: 'authenticity',
  attribute: 'creatorDeclarationFictionalEnabled'
}, {
  key: 'personal_opinion',
  icon: 'fas fa-comment-dots',
  color: '#2563eb',
  category: 'authenticity',
  attribute: 'creatorDeclarationPersonalOpinionEnabled'
}, {
  key: 'professional',
  icon: 'fas fa-triangle-exclamation',
  color: '#d97706',
  category: 'safety',
  attribute: 'creatorDeclarationProfessionalEnabled',
  detailsType: 'text'
}, {
  key: 'sensitive',
  icon: 'fas fa-eye-slash',
  color: '#ea580c',
  category: 'safety',
  attribute: 'creatorDeclarationSensitiveEnabled',
  detailsType: 'text'
}, {
  key: 'self_promotion',
  icon: 'fas fa-bullhorn',
  color: '#0891b2',
  category: 'commercial',
  attribute: 'creatorDeclarationSelfPromotionEnabled'
}, {
  key: 'sponsored',
  icon: 'fas fa-handshake',
  color: '#0f766e',
  category: 'commercial',
  attribute: 'creatorDeclarationSponsoredEnabled',
  detailsType: 'text'
}];
function configuredOrder() {
  return String(app.forum.attribute('creatorDeclarationOrder') || '').split(',').map(key => key.trim());
}
function orderIndex(key, order) {
  const configuredIndex = order.indexOf(key);
  if (configuredIndex !== -1) return configuredIndex;
  const definitionIndex = definitions.findIndex(definition => definition.key === key);
  return order.length + (definitionIndex === -1 ? definitions.length : definitionIndex);
}
export function enabledDefinitions(preservedKeys) {
  if (preservedKeys === void 0) {
    preservedKeys = [];
  }
  const order = configuredOrder();
  return definitions.filter(definition => app.forum.attribute(definition.attribute) !== false || preservedKeys.includes(definition.key)).sort((a, b) => orderIndex(a.key, order) - orderIndex(b.key, order));
}
export function sortDeclarations(models) {
  const order = configuredOrder();
  return [...models].sort((a, b) => orderIndex(a.key(), order) - orderIndex(b.key(), order));
}
export function definitionFor(key) {
  return definitions.find(definition => definition.key === key);
}
export function labelFor(key) {
  return app.translator.trans(`ffans-creator-declarations.lib.declarations.${key}.label`);
}
export function selectionsFromModels(models) {
  return models.map(model => ({
    key: model.key(),
    details: model.metadata()?.details || '',
    title: model.metadata()?.title || ''
  }));
}
flarum.reg.add('ffans-creator-declarations', 'forum/utils/declarations', { sourceDeclarationKeys: sourceDeclarationKeys,isSourceDeclarationKey: isSourceDeclarationKey,definitions: definitions,enabledDefinitions: enabledDefinitions,sortDeclarations: sortDeclarations,definitionFor: definitionFor,labelFor: labelFor,selectionsFromModels: selectionsFromModels, });